module.exports = __webpack_public_path__ + "static/media/logo.7b4c1468.jpeg";